// extracted by mini-css-extract-plugin
export default {"underline":"Tabs_underline_FQZ1q"};